/* LB 4-11: el interruptor de «Envío protegido» solo actualiza total, línea de descuento y contador; no repinta «Completa tu look». Usa XHR para no pasar por el parche de fetch de lb-carrito.js. */
(function () {
  'use strict';
  var root = document.getElementById('lbc'); if (!root) return;
  var SECTION = 'lb-carrito', busy = false;
  function onCart() { return /^\/cart\/?$/.test(window.location.pathname); }
  function msg(t) { var m = root.querySelector('[data-lbc-msg]'); if (!m) return; m.textContent = t; m.hidden = false; setTimeout(function () { m.hidden = true; }, 4500); }
  function xhr(url, body, ok, ko) {
    var x = new XMLHttpRequest(); x.open('POST', url); x.withCredentials = true;
    x.setRequestHeader('Content-Type', 'application/json'); x.setRequestHeader('Accept', 'application/json'); x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    x.onload = function () { var d = null; try { d = JSON.parse(x.responseText); } catch (e) {} if (x.status >= 200 && x.status < 300 && d && !d.status) ok(d); else ko(); };
    x.onerror = ko; x.send(JSON.stringify(body));
  }
  function patch(sections) {
    var html = sections && sections[SECTION], cur = document.getElementById('lbc-inner');
    if (!html || !cur) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#lbc-inner'); if (!fresh) return;
    ['data-count', 'data-prot-q', 'data-prot-vid'].forEach(function (a) { var v = fresh.getAttribute(a); if (v !== null) cur.setAttribute(a, v); });
    var t1 = cur.querySelector('[data-lbc-total]'), t2 = fresh.querySelector('[data-lbc-total]'); if (t1 && t2) t1.textContent = t2.textContent;
    ['.lbc__tier', '.lbc__items'].forEach(function (sel) { var a = cur.querySelector(sel), b = fresh.querySelector(sel); if (a && b) a.replaceWith(b); });
    var ti = cur.querySelector('#lbc-title'), tf = fresh.querySelector('#lbc-title'); if (ti && tf) ti.textContent = tf.textContent;
    var n = parseInt(cur.getAttribute('data-count'), 10) || 0, bub = document.getElementById('cart-icon-bubble');
    if (bub && sections['cart-icon-bubble']) {
      var t = document.createElement('div'); t.innerHTML = sections['cart-icon-bubble'];
      var inner = t.querySelector('.shopify-section') || t; bub.innerHTML = inner.innerHTML;
      var b = bub.querySelector('.cart-count-bubble');
      if (b) { if (n === 0) b.remove(); else { var s1 = b.querySelector('span[aria-hidden]'); if (s1) s1.textContent = n; var s2 = b.querySelector('.visually-hidden'); if (s2) s2.textContent = s2.textContent.replace(/\d+/, n); } }
    }
  }
  var NO = 'lbc_noprot';
  function flag(v) { try { if (v) window.localStorage.setItem(NO, '1'); else window.localStorage.removeItem(NO); } catch (e) {} }
  function flagged() { try { return !!window.localStorage.getItem(NO); } catch (e) { return false; } }
  function setProt(inp, on) {
    var id = inp.getAttribute('data-lbc-prot'), lab = inp.closest('label');
    if (!id || busy) { inp.checked = !on; return; }
    busy = true; if (lab) lab.classList.add('is-busy');
    var body = on ? { items: [{ id: Number(id), quantity: 1 }] } : { id: String(id), quantity: 0 };
    body.sections = SECTION + ',cart-icon-bubble'; body.sections_url = window.location.pathname;
    xhr(on ? '/cart/add.js' : '/cart/change.js', body,
      function (d) { patch(d.sections); if (lab) lab.classList.remove('is-busy'); busy = false; },
      function () { inp.checked = !on; if (lab) lab.classList.remove('is-busy'); busy = false; msg('No se ha podido cambiar el envío protegido. Inténtalo de nuevo.'); });
  }
  window.addEventListener('change', function (ev) {
    var inp = ev.target && ev.target.closest && ev.target.closest('input[data-lbc-prot]');
    if (!inp || onCart()) return;
    ev.stopImmediatePropagation();
    flag(!inp.checked);
    setProt(inp, inp.checked);
  }, true);
  /* Seguro marcado por defecto: en cuanto hay prendas en la cesta y no lo ha quitado el cliente, se añade solo */
  function ensure() {
    if (busy || onCart()) return;
    var inner = document.getElementById('lbc-inner'); if (!inner) return;
    var n = parseInt(inner.getAttribute('data-count'), 10) || 0;
    if (!n) { flag(false); return; }
    var vid = inner.getAttribute('data-prot-vid'), pq = parseInt(inner.getAttribute('data-prot-q'), 10) || 0;
    if (!vid || pq > 0 || flagged()) return;
    var inp = inner.querySelector('input[data-lbc-prot]'); if (!inp || inp.disabled) return;
    inp.checked = true; setProt(inp, true);
  }
  /* LB 4-11 auditoría: etiquetas de los tramos en dos líneas (4 / −20 %) para que no se pisen en pantallas estrechas */
  (function () {
    var st = document.createElement('style');
    st.textContent = '.lbc__reward-steps{height:32px !important}.lbc__reward-steps span{line-height:1.2;text-align:center;font-size:10.5px}.lbc__reward-steps span:last-child{text-align:right}';
    document.head.appendChild(st);
  })();
  function steps() {
    [].forEach.call(root.querySelectorAll('.lbc__reward-steps span'), function (s) {
      var t = s.textContent; if (t.indexOf('·') < 0) return;
      var p = t.split('·'); s.innerHTML = p[0].trim() + '<br>' + p[1].trim();
    });
  }
  var et = null;
  function soon() { clearTimeout(et); et = setTimeout(ensure, 250); }
  if (window.MutationObserver) new MutationObserver(function () { steps(); soon(); }).observe(root, { childList: true, subtree: true });
  steps(); soon();
})();